import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

const INPUT_NAME = {
  shortDescription: 'mô tả thông tin ngắn gọn',
  description: 'mô tả thông tin',
};

const useUpdateProfile = () => {
  const [formData, setFormData] = useState({});
  const refEditor = useRef();
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [error, setError] = useState({});
  const user = useSelector((state) => state.app.user);
  const [contentText, setContentText] = useState();

  const handleEditor = (html) => {
    setContentText(html);
  };

  const handleOnChangeForm = (e, key) => {
    let value;
    if (key === 'shortDescription' && e.target.value.length >= 200) {
      setFormData({ ...formData, [`${key}`]: e.target.value.slice(0, 200) });
      return;
    }
    if (key === 'thumbnail' || key === 'profile_img') {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = function () {
        value = reader.result;
        formData[key] = value;
        setFormData({ ...formData });
      };
      reader.readAsDataURL(file);
      return;
    } else {
      value = e.target.value;
    }
    setFormData({ ...formData, [`${key}`]: value });
  };

  const handleUpdateProfile = () => {
    const data = { ...formData, description: contentText };
    const checkDataForm = Object.entries(data);
    for (let index = 0; index < checkDataForm.length; index++) {
      const [key, value] = checkDataForm[index];
      if (!value || value == '') {
        setError({
          isError: true,
          title: 'Thất bại',
          body: `Vui lòng nhập ${INPUT_NAME[key]}.`,
          onHandle: () => {
            setIsShowPopup(false);
          },
        });
        setIsShowPopup(true);
        return;
      }
      if (key === 'shortDescription' && value.length > 200) {
        setError({
          isError: true,
          title: 'Thất bại',
          body: `Phần mô tả tin tức ngắn gọn không được quá 200 kí tự.`,
          onHandle: () => {
            setIsShowPopup(false);
          },
        });
        setIsShowPopup(true);
        return;
      }
    }
    setError({
      isError: false,
      title: 'Xác nhận',
      body: `Bạn có muốn cập nhật thông tin hay không?`,
      onHandle: () => {
        axios
          .post(`/api/v1/platform/profile/update/${user.name.toUpperCase()}`, {
            ...data,
          })
          .then(({ data }) => {
            if (data.success) {
              window.location.href = '/bang-dieu-khien';
              return;
            }
          });
      },
    });
    setIsShowPopup(true);
  };

  useEffect(() => {
    if (user) {
      axios
        .get(`/api/v1/platform/profile/${user.name.toUpperCase()}`)
        .then(({ data }) => {
          if (data.success) {
            let platform = { ...data.payload };
            setContentText(platform.description);
            setFormData({ ...platform });
            return;
          }
        });
    }
  }, [user]);

  return {
    isShowPopup,
    setIsShowPopup,
    error,
    formData,
    handleOnChangeForm,
    handleUpdateProfile,
    refEditor,
    handleEditor,
  };
};

export default useUpdateProfile;
